/* ============================================
   BREW HOUSE — Hero Slideshow JavaScript
   ============================================ */

(function () {
  'use strict';

  class HeroSlideshow {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('[data-slideshow-track]');
      this.slides = container.querySelectorAll('[data-slideshow-slide]');
      this.prevBtn = container.querySelector('[data-slideshow-prev]');
      this.nextBtn = container.querySelector('[data-slideshow-next]');
      this.pages = container.querySelectorAll('[data-slideshow-page]');

      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplayInterval = null;
      this.autoplayDelay = parseInt(container.dataset.autoplay) || 6000;
      this.isAutoplay = container.dataset.autoplay !== '0';

      if (this.totalSlides <= 1) return;

      this.bindEvents();
      if (this.isAutoplay) this.startAutoplay();
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.resetAutoplay();
      });

      this.nextBtn?.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.resetAutoplay();
      });

      this.pages.forEach((page, i) => {
        page.addEventListener('click', () => {
          this.goTo(i);
          this.resetAutoplay();
        });
      });

      /* Pause autoplay on hover */
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => {
        if (this.isAutoplay) this.startAutoplay();
      });

      /* Touch/swipe support */
      let touchStartX = 0;
      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.goTo(this.currentIndex + 1) : this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        }
      }, { passive: true });
    }

    goTo(index) {
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.currentIndex = index;
      this.track.style.transform = `translateX(-${index * 100}%)`;

      /* Update pagination */
      this.pages.forEach((page, i) => {
        page.classList.toggle('hero-slideshow__page--active', i === index);
      });

      /* Update ARIA */
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i !== index);
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      if (this.isAutoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hero-slideshow]').forEach((el) => {
      new HeroSlideshow(el);
    });
  });
})();
